export const MAX_RESULTS = 1000;
